import { createAction } from 'redux-actions';

const NAVIGATION_TOGGLE_OPEN = 'NAVIGATION_TOGGLE_OPEN';
const HEADER_CHANGE_TYPE = 'HEADER_CHANGE_TYPE';

const navigationToggleRequest = createAction(NAVIGATION_TOGGLE_OPEN);
const changeHeaderTypeAction = createAction(HEADER_CHANGE_TYPE);

export const toggleNavigation = () => {
  return dispatch => {
    dispatch(navigationToggleRequest());
  };
};

export const changeHeaderType = (type) => {
  return dispatch => {
    dispatch(changeHeaderTypeAction({ type }));
  };
};

export const HEADER_TYPE_DEFAULT = 'default';
export const HEADER_TYPE_TRANSPARENT = 'transparent';

export const actions = {
  NAVIGATION_TOGGLE_OPEN,
  HEADER_CHANGE_TYPE,
};